// pages/BatchReports/BatchReportsPage.js
import React, { useEffect, useState } from "react";
import { Grid, Paper, Typography } from "@material-ui/core";
import PageTitle from "components/PageTitle/PageTitle";
import useStyles from "./styles";
import BatchReportsTable from "components/MUIDatatable/BatchReportsTable";
import BatchReportSubmitSection from "components/BatchReports/BatchReportSubmitSection";
import { dbGet } from "utils/DBFetchers";

export default function BatchReportsPage() {
  const classes = useStyles();

  const [tasksByKey, setTasksByKey] = useState({});
  const [manifestEtag, setManifestEtag] = useState(null);
  const [manifestLoading, setManifestLoading] = useState(false);
  const [manifestError, setManifestError] = useState(null);

  useEffect(() => {
    let active = true;

    const fetchManifest = async () => {
      setManifestLoading(true);
      setManifestError(null);

      try {
        // Backend: GET /cli/batch/report_manifest
        const resp = await dbGet("cli/batch/report_manifest");

        const reportManifestJson = resp?.report_manifest_json || resp?.data?.report_manifest_json;
        const etag = resp?.etag || resp?.data?.etag;

        if (!reportManifestJson || typeof reportManifestJson !== "object") {
          throw new Error("Manifest inválido: no llegó report_manifest_json como objeto.");
        }

        if (active) {
          setTasksByKey(reportManifestJson);
          setManifestEtag(etag || null);
        }
      } catch (err) {
        if (active) {
          setManifestError("Error al cargar el manifest de reportes.");
        }
      } finally {
        if (active) setManifestLoading(false);
      }
    };

    fetchManifest();

    return () => {
      active = false;
    };
  }, []);

  return (
    <Grid>
      <PageTitle title="Tareas" />

      <Paper elevation={3} className={classes.paperContainer}>
        <Grid container direction="column" spacing={3} style={{ padding: 16, background: "#f5f5f5" }}>
          <Grid item xs={12} style={{ marginTop: 16, overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
            <BatchReportsTable />
          </Grid>

          {/* Estado de carga del manifest */}
          <Grid item>
            {manifestLoading ? (
              <Typography color="textSecondary">Cargando manifest...</Typography>
            ) : null}

            {manifestError ? (
              <Typography color="error">{manifestError}</Typography>
            ) : null}

            {!manifestLoading && !manifestError && manifestEtag ? (
              <Typography variant="caption" color="textSecondary">
                Manifest ETag: {manifestEtag}
              </Typography>
            ) : null}
          </Grid>

          {/* Sección submit separada */}
          {!manifestLoading && !manifestError ? (
            <Grid item>
              <BatchReportSubmitSection tasksByKey={tasksByKey} />
            </Grid>
          ) : null}
        </Grid>
      </Paper>
    </Grid>
  );
}
